export default __webpack_public_path__ + "static/media/delivery-man.c76f8767.svg";